import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { parseSeconds } from '../../../helpers/helpers';

// Components
import Checkbox from '../../common/Checkbox';

const Incidents = observer(class Incidents extends React.Component {
  handleFilter(hideInfoFlags) {
    const { PlayerStore } = this.props.store;

    PlayerStore.hideInfoFlags = hideInfoFlags;
  }

  render() {
    const { onSeek, store, translation } = this.props;
    const { hideInfoFlags } = store.PlayerStore;
    let { flags } = this.props;

    // Sort flags by timestamp
    function compare(a, b) {
      if (a.sessionTime < b.sessionTime) {
        return -1;
      } else if (a.sessionTime > b.sessionTime) {
        return 1;
      }

      return 0;
    }

    flags = flags.slice().sort(compare);

    return (
      <section>
        <h2 className="meta">{translation.title}</h2>

        {(!flags || flags.length === 0) &&
          <span className="no-results">{translation.no_results}</span>
        }

        {flags && flags.length > 0 &&
          <div>
            <footer className="tab-panel__head">
              <Checkbox
                defaultChecked={true}
                id="incidents-filter"
                label={translation.hide_info}
                value={true}
                onChange={(e) => this.handleFilter(e.target.checked)}
              />
            </footer>

            <ol className="data data--full">
              {flags.map(
                (flag, i) => {
                  if (
                    (hideInfoFlags && flag.severity !== 'green') ||
                    !hideInfoFlags
                  ) {
                    return (
                      <li
                        className="data__clickable-row"
                        key={i}
                        onClick={() => onSeek(flag.sessionTime)}
                      >
                        <strong
                          className={`severity severity--${flag.severity}`}
                        >
                          {flag.title}
                        </strong>

                        <span>{parseSeconds(flag.sessionTime)}</span>
                      </li>
                    );
                  }

                  return null;
                }
              )}
            </ol>
          </div>
        }
      </section>
    )
  }
})

export default Incidents;
